
export const CommonAccountConstant = {
    Table: {
        PRIORITY: "Priority",
        CONSORTIUM_CODE: "Consortium Code",
        VESSEL_CODE: "Vessel Code",
        VOYAGE_CODE: "Voyage Code",
        SERVICE_CODE: "Service Code",
        SOA: "SOA",
        ETD: "ETD",
        ETB: "ETB", //update by betty
        STATUS: "Status",
        ACTIVE_IND: "Active Ind.",
        BILL_TO_COMPANY: "Bill-To Company",
        CHARGE_ON_COMPANY: "Charge-On Company",
        PERCENTAGE: "Percentage",
    },
    Title: {
        CATEGORY: "Charge",
        TITLE: "Common Account",
        COMPANY_TITLE: "Common Account Company",
    },
}
export const commonAccountRequiredFieldList: string[] = [
    // 'commonAcType',
    'activeInd',
];
export const commonAccountCompanyRequiredFieldList: string[] = [
    'chargeOnCompany',
    'billToCompany',
    'percentage',
];